import FORMFIELD from '../../../../DOM/form/fieldset/formfieldgroup/formfield/FORMFIELD.js';
import { HTMLELEMENT } from '../../../../../enums/HTMLELEMENT.js';
import GROUP from '../../../../DOM/GROUP/GROUP.js';
import { HTTPINPUTTYPE } from '../../../../../enums/HTTPINPUTTYPE.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import FORMINPUTCHECKBOX from '../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTCHECKBOX.js';
import FORMINPUTFILE from '../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTFILE.js';
import FORMINPUTPASSWORD from '../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTPASSWORD.js';
import FORMINPUTRADIO from '../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTRADIO.js';
import FORMINPUTTEXT from '../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTTEXT.js';
import FORMSELECT from '../../../../DOM/form/fieldset/formfieldgroup/formfield/formselect/FORMSELECT.js';
import FORMTEXTAREA from '../../../../DOM/form/fieldset/formfieldgroup/formfield/formtextarea/FORMTEXTAREA.js';
import BUTTONGROUP from '../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import DIV from '../../../../DOM/div/DIV.js';
import FORMINPUTTEL from '../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTTEL.js';
import HEADER from '../../../../DOM/header/HEADER.js';
import NAVBAR from '../../../../DOM/nav/navbar/NAVBAR.js';
import FORMINPUTDATE from '../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTDATE.js';
import FORMINPUTDATETIME from '../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTDATETIME.js';
import FORMINPUTTIME from '../../../../DOM/form/fieldset/formfieldgroup/formfield/forminput/forminputs/FORMINPUTTIME.js';
// Model Structure
export const formFieldGroupAttr = makeAttrStruct([
    ['name'],
    ['class']
]);
export const formFieldGroupData = makeDataStruct([
    ['formfields', []]
]);
export const formFieldGroupModel = makeStruct([
    ['attributes', formFieldGroupAttr],
    ['data', formFieldGroupData]
]);
// Simplified Model
export function formFieldGroup(name, className, formfields) {
    return {
        attributes: formFieldGroupAttr(name, className),
        data: formFieldGroupData(formfields)
    };
}
/** A collection of Form fields */
export default class FORMFIELDGROUP extends GROUP {
    constructor(node, model) {
        super(node, HTMLELEMENT.DIV, model);
        this.addClass('form-field-group');
    }
    addDiv(model) {
        return this.addChild(new DIV(this, model));
    }
    /** Adds a header to this element */
    addHeader(model) {
        return this.addChild(new HEADER(this, model));
    }
    addNavBar(model) {
        return this.addChild(new NAVBAR(this, model));
    }
    getFormFields(name) {
        return this.get().filter((c) => c instanceof FORMFIELD &&
            (name === undefined || c.name === name || c.attributes?.name === name));
    }
    addFormInputCheckbox(model) {
        return this.addChild(new FORMINPUTCHECKBOX(this, model));
    }
    addFormInputFile(model) {
        return this.addChild(new FORMINPUTFILE(this, model));
    }
    addFormInputPassword(model) {
        return this.addChild(new FORMINPUTPASSWORD(this, model));
    }
    addFormInputRadio(model) {
        return this.addChild(new FORMINPUTRADIO(this, model));
    }
    addFormInputText(model) {
        return this.addChild(new FORMINPUTTEXT(this, model));
    }
    addFormInputTel(model) {
        return this.addChild(new FORMINPUTTEL(this, model));
    }
    addFormInputDate(model) {
        return this.addChild(new FORMINPUTDATE(this, model));
    }
    addFormInputDateTime(model) {
        return this.addChild(new FORMINPUTDATETIME(this, model));
    }
    addFormInputTime(model) {
        return this.addChild(new FORMINPUTTIME(this, model));
    }
    addFormSelect(model) {
        return this.addChild(new FORMSELECT(this, model));
    }
    addFormTextarea(model) {
        return this.addChild(new FORMTEXTAREA(this, model));
    }
    addButtonGroup(model) {
        return this.addChild(new BUTTONGROUP(this, model));
    }
    getName() {
        return this.attributes.name;
    }
    getResults() {
        let results = {};
        // let errors: InvalidFormFieldError[] = [];
        let values = [];
        this.getFormFields().forEach((formField) => {
            let field = formField.getField();
            let value = field.getValue();
            // field.setError(field.checkValidity() ? null : new InvalidFormFieldError(field));
            if (field.getAttribute('type') === HTTPINPUTTYPE.CHECKBOX) {
                // For checkboxes, accumulate values into an array
                if (value !== null) {
                    values.push(value);
                }
                results[field.getName()] = values;
            }
            else {
                // For other input types, set the value directly
                // Only include non-null values (excludes unchecked radio buttons and checkboxes)
                if (value !== null) {
                    results[field.getName()] = value;
                }
            }
        });
        // return { results, errors };
        return results;
    }
    getFieldset() {
        return this.getProtoTypeByClass('FIELDSET');
    }
}
